export const Constants = {
  dateFormat: 'YYYY-MM-DD HH:mm',
  dateTimePickerFormat: 'yyyy-MM-dd HH:mm',
};
